import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LocationSelector from '../components/common/LocationSelector';
import ClinicsList from '../components/common/ClinicsList';
import { getClinicsByCity } from '../services/api';

const ManageClinic = () => {
    const navigate = useNavigate();
    const [selectedLocation, setSelectedLocation] = useState({ stateId: null, cityId: null });
    const [clinics, setClinics] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (selectedLocation.cityId) {
            fetchClinicsByCity();
        }
    }, [selectedLocation.cityId]);

    const fetchClinicsByCity = async () => {
        try {
            setLoading(true);
            setError(null);
            console.log('Fetching clinics for cityId:', selectedLocation.cityId);
            const response = await getClinicsByCity({cityId: selectedLocation.cityId});
            console.log('API Response:', response);
            if (response.success) {
                console.log('Setting clinics data:', response.data);
                // Show all clinics for management (removed isActive filter since it's not in API response)
                setClinics(response.data);
            }
        } catch (err) {
            setError('Failed to fetch clinics. Please try again.');
            console.error('Error fetching clinics:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleLocationSelect = (location) => {
        setSelectedLocation(location);
        setError(null);
    };

    const handleManage = (clinicId) => {
        navigate(`/clinic/${clinicId}`);
    };

    return (
        <div className="container mx-auto px-4 py-8">
            <div className="mb-8">
                <h1 className="text-3xl font-bold text-gray-900">Manage Clinics</h1>
                <p className="mt-2 text-gray-600">Select a location to view and manage active clinics.</p>
            </div>

            {/* Location Selection */}
            <div className="bg-white rounded-lg shadow-md p-6 mb-8">
                <h2 className="text-xl font-semibold text-gray-900 mb-4">Location Selection</h2>
                <LocationSelector 
                    onLocationSelect={handleLocationSelect}
                    onFetchClinics={fetchClinicsByCity}
                    showFetchButton={true}
                    className="w-full"
                />
            </div>

            {/* Clinics List */}
            <ClinicsList
                clinics={clinics}
                loading={loading}
                error={error}
                selectedLocation={selectedLocation}
                title="Active Clinics"
                onClinicAction={handleManage}
                showActionButton={true}
                gridCols="grid-cols-1 md:grid-cols-2 lg:grid-cols-3"
                isFromManagement={true}
            />
        </div>
    );
};

export default ManageClinic; 